const BUILD_SIGNATURE_KEY = 'homeworkAppBuildSignature';
let refreshing = false;
let hadController = false;

export function register() {
    if ('serviceWorker' in navigator) {
        hadController = Boolean(navigator.serviceWorker.controller);

        // Wait for the page to load before registering the service worker
        window.addEventListener('load', () => {
        const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

        navigator.serviceWorker
            .register(swUrl)
            .then((registration) => {
            console.log('Service Worker registered with scope:', registration.scope);
            startVersionChecks(registration);

            // Optional: Handle updates to the service worker
            registration.onupdatefound = () => {
                const installingWorker = registration.installing;
                if (installingWorker) {
                installingWorker.onstatechange = () => {
                    if (installingWorker.state === 'installed') {
                    if (navigator.serviceWorker.controller) {
                        installingWorker.postMessage({ type: 'SKIP_WAITING' });
                    } else {
                        // Content is cached for offline use.
                        console.log('Content is cached for offline use.');
                    }
                    }
                };
                }
            };
            })
            .catch((error) => {
            console.error('Error during service worker registration:', error);
            });
        });

        navigator.serviceWorker.addEventListener('controllerchange', () => {
            if (!hadController) {
                hadController = true;
                return;
            }

            if (refreshing) {
                return;
            }

            refreshing = true;
            window.location.reload();
        });
    }
}

// This function unregisters the service worker
export function unregister() {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready.then((registration) => {
        registration.unregister();
        });
    }
}

function startVersionChecks(registration) {
    checkForNewBuild(registration);

    window.addEventListener('focus', () => checkForNewBuild(registration));
    window.addEventListener('online', () => checkForNewBuild(registration));
    document.addEventListener('visibilitychange', () => {
        if (!document.hidden) {
            checkForNewBuild(registration);
        }
    });

    window.setInterval(() => checkForNewBuild(registration), 5 * 60 * 1000);
}

async function checkForNewBuild(registration) {
    try {
        await registration.update();

        const response = await fetch(`${process.env.PUBLIC_URL}/asset-manifest.json?updated=${Date.now()}`, {
            cache: 'no-store',
            headers: {
                'Cache-Control': 'no-cache',
            },
        });

        if (!response.ok) {
            return;
        }

        const manifest = await response.json();
        const signature = JSON.stringify(manifest.files || manifest);
        const previousSignature = localStorage.getItem(BUILD_SIGNATURE_KEY);

        if (!previousSignature) {
            localStorage.setItem(BUILD_SIGNATURE_KEY, signature);
            return;
        }

        if (previousSignature !== signature) {
            localStorage.setItem(BUILD_SIGNATURE_KEY, signature);
            await clearAppCaches();

            if (registration.waiting) {
                registration.waiting.postMessage({ type: 'SKIP_WAITING' });
                return;
            }

            window.location.reload();
        }
    } catch (error) {
        console.warn('Unable to check for app updates:', error);
    }
}

async function clearAppCaches() {
    if (!('caches' in window)) {
        return;
    }

    const cacheNames = await caches.keys();
    await Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName)));
}
